// The card never mounts a <video>, so the popup used to start from a cold
// cache. Warming on hover/touch buys back that half second: a detached element
// with preload="auto" makes the browser start buffering into its media cache,
// which the popup's <video> then reads from. Once per URL per page.
const warmed = new Set<string>();

export function warmVideo(url: string): void {
  if (typeof document === "undefined" || !url || warmed.has(url)) return;
  warmed.add(url);
  const video = document.createElement("video");
  video.preload = "auto";
  video.muted = true;
  video.src = url;
  video.load();
}
